/* Sereolys `freedom` product template kit.
 *
 *  - Announcement marquee at the top of <body> (competitor-style: white bar, brown
 *    text, scrolling "•" ticker) — French, this-template only.
 *  - Sticky CTA that appears once the reader is past the buy-box and scrolls back to it.
 *  - Every content CTA ("J'ESSAIE SEREOLYS SANS RISQUE") scrolls to the buy-box.
 *
 * Lives in an asset, not an inline <script>: inline scripts inside these sections do
 * not survive to the DOM on this store. Reveal is polled and toggled with `display`
 * (this theme recomputes neither bottom nor transform; embedded contexts fire no
 * reliable scroll/IntersectionObserver callbacks).
 */
(function () {
  'use strict';

  var BAR_MSGS = ['Livraison offerte', 'Garantie 12 mois', 'Stock limité'];

  function buildBar() {
    if (document.getElementById('fp-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'fp-bar';
    var one = BAR_MSGS.map(function (m) {
      return '<span class="fp-bar__i">' + m + ' •</span>';
    }).join('');
    /* two identical sets so the -50% loop is seamless */
    bar.innerHTML = '<div class="fp-bar__track">' +
      '<div class="fp-bar__set">' + one + one + '</div>' +
      '<div class="fp-bar__set" aria-hidden="true">' + one + one + '</div>' +
      '</div>';
    document.body.insertBefore(bar, document.body.firstChild);
  }

  function buyBox() {
    return document.getElementById('offer') ||
           document.querySelector('product-form, .product-form, [id*="__main"] .product-form__buttons') ||
           document.querySelector('[id*="template--"][id*="__main"], #MainContent');
  }

  function goBuyBox() {
    var el = buyBox();
    var to = el ? Math.max(0, window.scrollY + el.getBoundingClientRect().top - 20) : 0;
    /* Manual tween — CSS smooth scrolling is ignored in some embedded/preview
     * contexts, so drive it with setInterval so it always moves. */
    var from = window.scrollY, d = to - from, t0 = Date.now();
    clearInterval(window.__fpTw);
    window.__fpTw = setInterval(function () {
      var k = Math.min(1, (Date.now() - t0) / 480);
      var s = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      window.scrollTo(0, Math.round(from + d * s));
      if (k >= 1) clearInterval(window.__fpTw);
    }, 16);
  }

  var stickyEl = null, stickyShown = null, sentinel = null;

  function buildSticky() {
    if (document.getElementById('fp-sticky')) return;
    stickyEl = document.createElement('div');
    stickyEl.id = 'fp-sticky';
    stickyEl.innerHTML =
      '<div class="fp-sticky__in"><div class="fp-sticky__t">' +
      '<div class="fp-sticky__t1"></div><div class="fp-sticky__t2"></div></div>' +
      '<button type="button" class="fp-sticky__btn"></button></div>';
    stickyEl.querySelector('.fp-sticky__t1').textContent = 'Sereolys — Protocole Liberté';
    stickyEl.querySelector('.fp-sticky__t2').textContent = 'Satisfait ou remboursé 60 jours';
    stickyEl.querySelector('.fp-sticky__btn').textContent = 'J’EN PROFITE';
    document.body.appendChild(stickyEl);
    stickyEl.querySelector('.fp-sticky__btn')
      .addEventListener('click', function (e) { e.preventDefault(); goBuyBox(); });
  }

  function applySticky(v) {
    if (v === stickyShown || !stickyEl) return;
    stickyShown = v;
    stickyEl.classList.toggle('fp-on', v);
    stickyEl.style.setProperty('display', v ? 'block' : 'none', 'important');
  }

  /* show once the buy-box has scrolled out of view above the fold */
  function checkSticky() {
    if (!stickyEl) return;
    if (!sentinel) sentinel = buyBox();
    if (sentinel) { applySticky(sentinel.getBoundingClientRect().bottom < 0); return; }
    applySticky(window.scrollY > 700);
  }

  /* EVERY link inside the cloned content sections goes to the offer (the buy-box),
   * same as the competitor's page routes all its CTAs to the product. */
  function wireCtas() {
    var links = document.querySelectorAll(
      '.section-custom-section a[href], .comparison-table a[href], .fpvid a[href], .lyv-readmore__link');
    [].slice.call(links).forEach(function (a) {
      if (a.__fp) return;
      a.__fp = 1;
      var h = a.getAttribute('href') || '';
      if (/^(mailto:|tel:)/i.test(h)) return;
      if (a.classList.contains('lyv-readmore__link')) return; /* read-more toggle keeps its job */
      a.addEventListener('click', function (e) { e.preventDefault(); goBuyBox(); });
    });
  }

  /* Read-more reviews (fp-08). The source hides the reviews after the 3rd behind a
   * "Lire plus d'avis" toggle via an inline <script>, which does not survive on this
   * store — so drive it here. Hide every visual sibling after the read-more wrapper,
   * reveal on click, and flip the label. */
  function isVisual(el) {
    return el && el.tagName !== 'STYLE' && el.tagName !== 'SCRIPT' &&
           el.tagName !== 'LINK' && el.tagName !== 'TEMPLATE';
  }
  function nextVisual(el) {
    var n = el.nextElementSibling;
    while (n && !isVisual(n)) n = n.nextElementSibling;
    return n;
  }
  function readmore(root) {
    var cs = (root || document).querySelectorAll('.lyv-readmore:not([data-fp-rm])');
    [].slice.call(cs).forEach(function (container) {
      container.setAttribute('data-fp-rm', '1');
      var btn = container.querySelector('.lyv-readmore__link');
      var label = container.querySelector('.lyv-readmore__label') || btn;
      if (!btn) return;
      var wrapper = container;
      while (wrapper.parentElement && !nextVisual(wrapper)) wrapper = wrapper.parentElement;
      wrapper.style.gridColumn = '1 / -1';
      var parent = wrapper.parentElement;
      var anchor = document.createComment('fp-rm'); parent.insertBefore(anchor, wrapper);
      var hidden = [], el = nextVisual(wrapper);
      while (el) { hidden.push(el); el.style.display = 'none'; el = nextVisual(el); }
      if (!hidden.length) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (!open) { hidden.forEach(function (b) { b.style.display = ''; }); parent.appendChild(wrapper); }
        else { hidden.forEach(function (b) { b.style.display = 'none'; }); parent.insertBefore(wrapper, anchor.nextSibling); }
        btn.setAttribute('aria-expanded', String(!open));
        if (label) label.textContent = open ? 'Lire plus d’avis ▾' : 'Afficher moins d’avis ▴';
      });
    });
  }

  /* Buy-box bundle text in French, editor-proof. The customizer keeps resetting
   * the lumin block titles/badges to the English theme default, so re-translate
   * them on the storefront by exact text-node match inside the buy-box. */
  var OFFER_FR = {
    'BUNDLE & SAVE': 'PACK & ÉCONOMIES',
    '1 Bottle': '1 Flacon', '2 Bottles': '2 Flacons', '3 Bottles': '3 Flacons',
    'You save 10%': 'Vous économisez 10%', 'You save 20%': 'Vous économisez 20%',
    'Most Popular': 'Le plus populaire',
    'Free Shipping With This Offer': 'Livraison offerte avec cette offre',
    '20% Off + Free Shipping': '-20% + Livraison offerte',
    'Best Value + Free Shipping': 'Meilleure offre + Livraison offerte',
    '90-Day Money-Back Guarantee': 'Satisfait ou remboursé 60 jours',
    'No questions asked': 'Sans condition',
    '24/7 Support': 'Support 24/7', 'Here to help': 'On vous aide',
    'Free Shipping': 'Livraison offerte', 'Globally': 'Partout',
    'Frequently Bought Together': 'Fréquemment achetés ensemble',
    '4.8 From 136 Reviews': '4,8 sur 136 avis'
  };
  function fixOffer() {
    var main = document.querySelector('[id*="__main"]');
    if (!main) return;
    var w = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var k = (t.nodeValue || '').trim();
      if (OFFER_FR.hasOwnProperty(k)) t.nodeValue = t.nodeValue.replace(k, OFFER_FR[k]);
    });
  }

  /* Review photos (Diane, James) + the fp-07 money-back seal are image-blocks that
   * the flattened responsive CSS left display:none on BOTH their desktop and mobile
   * copies, so they vanished. Each image also exists twice (same src). Show each
   * unique image once: first occurrence un-hidden, later duplicates hidden. */
  function fixImages() {
    var secs = document.querySelectorAll('.section-custom-section, .fpvid');
    [].slice.call(secs).forEach(function (sec) {
      var seen = {};
      [].slice.call(sec.querySelectorAll('img')).forEach(function (img) {
        var src = (img.currentSrc || img.src || '').split('?')[0];
        if (!src) return;
        var block = img.closest('.image-block') || img.parentElement;
        if (!block) return;
        if (seen[src]) { block.style.setProperty('display', 'none', 'important'); return; }
        seen[src] = 1;
        if (getComputedStyle(block).display === 'none') {
          block.style.setProperty('display', 'block', 'important');
        }
      });
    });
  }

    /* Review stars: the Material Symbols "star_rate" ligature does not paint here, so
   * render solid green unicode stars directly into each rating row. */
  function fixStars() {
    var ws = document.querySelectorAll('.section-custom-section .rating__stars, .comparison-table .rating__stars');
    [].slice.call(ws).forEach(function (w) {
      if (w.__fpstars) return; w.__fpstars = 1;
      var n = w.querySelectorAll('.rating-star, .material-symbols-rounded').length || 5;
      w.textContent = '★'.repeat(n);
      w.style.setProperty('color', '#00B67A', 'important');
      w.style.setProperty('font-family', 'Arial, sans-serif', 'important');
      w.style.setProperty('font-size', '18px', 'important');
      w.style.setProperty('line-height', '1', 'important');
      w.style.setProperty('letter-spacing', '1px', 'important');
      w.style.setProperty('display', 'inline-block', 'important');
      w.style.setProperty('width', 'auto', 'important');
      w.style.setProperty('height', 'auto', 'important');
      w.style.setProperty('overflow', 'visible', 'important');
    });
  }

  function init() { buildBar(); buildSticky(); wireCtas(); readmore(); fixOffer(); fixImages(); fixStars(); checkSticky(); }

  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 600);
  setTimeout(init, 1800);
  window.addEventListener('scroll', checkSticky, { passive: true });
  window.addEventListener('resize', checkSticky);
  setInterval(checkSticky, 400);
  /* the lumin bundle block renders/re-renders async — keep re-translating it for
   * the first few seconds, and again whenever a tier is selected. */
  var fixN = 0, fixTimer = setInterval(function () { fixOffer(); fixImages(); fixStars(); if (++fixN > 24) clearInterval(fixTimer); }, 400);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') setTimeout(fixOffer, 60);
  });
})();
